import { errorHandler } from './errorHandler'

/** Runs `operation`; a failure is reported through `errorHandler` and rethrown. */
export async function reportApiFailure<T>(
  operation: () => Promise<T>,
  fallback: string
): Promise<T> {
  try {
    return await operation()
  } catch (error) {
    errorHandler(error, fallback)
    throw error
  }
}
